import PropTypes from 'prop-types';
import { Row, Col } from '../../utils/grid/Grid';
import HostTeaserBig from './HostTeaserBig';

import './host-teaser-list.css';

interface HostTeaserBigListProps {
  hosts: any[];
  showPrices?: boolean;
}

export default function HostTeaserBigList({
  hosts,
  showPrices,
}: HostTeaserBigListProps): JSX.Element {
  return (
    <Row>
      {hosts.map((host, index) => (
        <Col xs={12} sm={6} md={4} key={index} className="host-teaser-list">
          <HostTeaserBig {...host} showPrices={showPrices} />
        </Col>
      ))}
    </Row>
  );
}

HostTeaserBigList.propTypes = {
  hosts: PropTypes.arrayOf(PropTypes.object).isRequired,
  showPrices: PropTypes.bool,
};

const defaultProps: Pick<HostTeaserBigListProps, 'showPrices'> = {
  showPrices: true,
};

HostTeaserBigList.defaultProps = defaultProps;
